import ManageSubjectJournalPost from "./ManageSubjectJournalPost";
export default ManageSubjectJournalPost;
